/* tslint:disable */
/* eslint-disable */
/**
 * Indexer Application API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface PredpisZbierky
 */
export interface PredpisZbierky {
    /**
     * 
     * @type {string}
     * @memberof PredpisZbierky
     */
    'iri'?: string;
    /**
     * 
     * @type {string}
     * @memberof PredpisZbierky
     */
    'menovka'?: string;
    /**
     * 
     * @type {string}
     * @memberof PredpisZbierky
     */
    'popis'?: string;
}
/**
 * 
 * @export
 * @interface PredpisZbierkyRozsirene
 */
export interface PredpisZbierkyRozsirene {
    /**
     * 
     * @type {Array<PredpisZbierkyRozsireneItem>}
     * @memberof PredpisZbierkyRozsirene
     */
    'docs'?: Array<PredpisZbierkyRozsireneItem>;
}
/**
 * 
 * @export
 * @interface PredpisZbierkyRozsireneItem
 */
export interface PredpisZbierkyRozsireneItem {
    /**
     * 
     * @type {string}
     * @memberof PredpisZbierkyRozsireneItem
     */
    'iri'?: string;
    /**
     * 
     * @type {string}
     * @memberof PredpisZbierkyRozsireneItem
     */
    'cislo'?: string;
    /**
     * 
     * @type {string}
     * @memberof PredpisZbierkyRozsireneItem
     */
    'nazov'?: string;
}

/**
 * PredpisZbierkyApi - axios parameter creator
 * @export
 */
export const PredpisZbierkyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [iri] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredpisZbierkyByIri: async (iri?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/predpisZbierky/rozsirene`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (iri !== undefined) {
                localVarQueryParameter['iri'] = iri;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dopyt] search text
         * @param {string} [typ] 
         * @param {string} [sort] 
         * @param {number} [rows] Maximum number of results in the output (default 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredpisZbierkyList: async (dopyt?: string, typ?: string, sort?: string, rows?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/predpisZbierky/navrhy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dopyt !== undefined) {
                localVarQueryParameter['dopyt'] = dopyt;
            }

            if (typ !== undefined) {
                localVarQueryParameter['typ'] = typ;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (rows !== undefined) {
                localVarQueryParameter['rows'] = rows;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PredpisZbierkyApi - functional programming interface
 * @export
 */
export const PredpisZbierkyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PredpisZbierkyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [iri] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPredpisZbierkyByIri(iri?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PredpisZbierkyRozsirene>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPredpisZbierkyByIri(iri, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredpisZbierkyApi.getPredpisZbierkyByIri']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [dopyt] search text
         * @param {string} [typ] 
         * @param {string} [sort] 
         * @param {number} [rows] Maximum number of results in the output (default 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPredpisZbierkyList(dopyt?: string, typ?: string, sort?: string, rows?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PredpisZbierky>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPredpisZbierkyList(dopyt, typ, sort, rows, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredpisZbierkyApi.getPredpisZbierkyList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PredpisZbierkyApi - factory interface
 * @export
 */
export const PredpisZbierkyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PredpisZbierkyApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [iri] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredpisZbierkyByIri(iri?: string, options?: any): AxiosPromise<PredpisZbierkyRozsirene> {
            return localVarFp.getPredpisZbierkyByIri(iri, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dopyt] search text
         * @param {string} [typ] 
         * @param {string} [sort] 
         * @param {number} [rows] Maximum number of results in the output (default 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredpisZbierkyList(dopyt?: string, typ?: string, sort?: string, rows?: number, options?: any): AxiosPromise<Array<PredpisZbierky>> {
            return localVarFp.getPredpisZbierkyList(dopyt, typ, sort, rows, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PredpisZbierkyApi - object-oriented interface
 * @export
 * @class PredpisZbierkyApi
 * @extends {BaseAPI}
 */
export class PredpisZbierkyApi extends BaseAPI {
    /**
     * 
     * @param {string} [iri] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredpisZbierkyApi
     */
    public getPredpisZbierkyByIri(iri?: string, options?: RawAxiosRequestConfig) {
        return PredpisZbierkyApiFp(this.configuration).getPredpisZbierkyByIri(iri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dopyt] search text
     * @param {string} [typ] 
     * @param {string} [sort] 
     * @param {number} [rows] Maximum number of results in the output (default 100)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredpisZbierkyApi
     */
    public getPredpisZbierkyList(dopyt?: string, typ?: string, sort?: string, rows?: number, options?: RawAxiosRequestConfig) {
        return PredpisZbierkyApiFp(this.configuration).getPredpisZbierkyList(dopyt, typ, sort, rows, options).then((request) => request(this.axios, this.basePath));
    }
}



